export default __webpack_public_path__ + "static/media/magnet.1ae849e8.svg";